<template>
    <v-container fluid>
        <v-card>
            <v-card-title>
                <v-row 
                    no-gutters 
                    align="start" 
                    justify="space-between">
                    <v-col sm="auto">
                        <div class="title">
                            Administrador | Inicio
                        </div>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text class="mt-5">
                <v-row>
                    <v-col 
                        cols="12" 
                        md="3" 
                        xs="12">
                        <v-hover>
                            <template v-slot="{ hover }">
                                <v-card
                                    :elevation="hover ? 24 : 6"
                                    class="mx-auto card-ug"
                                    shaped
                                    @click="
                                        $router.push({ name: 'validacionSolicitudesAdministrador' })
                                    "
                                >
                                    <v-card-title>
                                        <v-icon 
                                            class="azul-ug" 
                                            large 
                                            left>
                                            mdi-briefcase-check
                                        </v-icon>
                                        <span class="title font-weight-light azul-ug">
                                            Validación de solicitudes
                                        </span>
                                    </v-card-title>
                                    <v-card-text>
                                        <v-row>
                                            <v-col 
                                                class="py-1" 
                                                cols="12">
                                                &nbsp;
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col 
                                                v-if="loading" 
                                                class="py-1" 
                                                cols="12">
                                                <v-skeleton-loader type="text" />
                                            </v-col>
                                            <v-col 
                                                v-else 
                                                class="py-1" 
                                                cols="12">
                                                Solicitudes pendientes
                                                <v-chip
                                                    class="mx-2"
                                                    small
                                                    color="primary"
                                                    style="float:right;"
                                                >
                                                    {{ solicitudes }}
                                                </v-chip>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </template>
                        </v-hover>
                    </v-col>
                    <!-- <v-col cols="12" md="3" xs="12">
            <v-hover>
              <template v-slot="{ hover }">
                <v-card
                  class="mx-auto card-ug"
                  :elevation="hover ? 24 : 6"
                  shaped
                >
                  <v-card-title>
                    <v-icon class="azul-ug" large left>
                      mdi-bookmark-multiple
                    </v-icon>
                    <span class="title font-weight-light azul-ug">
                      Servicios
                    </span>
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col v-if="loading" class="py-1" cols="12">
                        <v-skeleton-loader type="text" />
                      </v-col>
                      <v-col v-else class="py-1" cols="12">
                        Mis servicios
                        <v-chip
                          class="mx-2 text-end"
                          small
                          color="primary"
                          style="float:right;"
                        >
                          {{ servicios }}
                        </v-chip>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col v-if="loading" class="py-1" cols="12">
                        <v-skeleton-loader type="text" />
                      </v-col>
                      <v-col v-else class="py-1" cols="12">
                        Usuarios activos
                        <v-chip
                          class="mx-2 text-end"
                          small
                          color="primary"
                          style="float:right;"
                        >
                          {{ usuariosActivos }}
                        </v-chip>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </template>
            </v-hover>
          </v-col> -->
                </v-row>
            </v-card-text>
        </v-card>
        <v-snackbar
            key="snackbar_bandejaadministrador"
            v-model="snackbarError"
            :bottom="true"
            :multi-line="true"
            color="error"
        >
            {{ textoError }}
            <v-btn 
                dark 
                text 
                @click="snackbarError = false">
                Cerrar
            </v-btn>
        </v-snackbar>
    </v-container>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { getInformacionBandejaAdministrador } from "@/api";

export default {
  name: "BandejaAdministrador",
  props: {},
  data () {
    return {
      solicitudes: 0,
      servicios: 0,
      usuariosActivos: 0,
      loading: true,
      snackbarError: false,
      textoError: ""
    };
  },
  computed: {},
  mounted () {
    this.getInfoBandejaAdministrador();
  },
  methods: {
    async getInfoBandejaAdministrador () {
      var self = this;
      self.loading = true;

      self.snackbarError = false;
      self.textoError = "";

      try {
        let response = await getInformacionBandejaAdministrador();

        if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "True") {
              self.solicitudes = response.data.data.solicitudes;
              self.servicios = response.data.data.servicios;
              self.usuariosActivos = response.data.data.usuariosActivos;
            }
          } else {
            self.snackbarError = true;
            self.textoError = response.data.message;
          }
        } else {
          self.snackbarError = true;
          self.textoError = "Error de red";
        }

        self.loading = false;
      } catch (e) {
        self.loading = false;
        self.snackbarError = true;
        self.textoError = e;
      }
    }
  }
};
</script>

<style>
.card-ug {
  border: 1px solid #b5a36a !important;
}

.azul-ug {
  color: #0e345b !important;
}
</style>
